import {createSlice} from "@reduxjs/toolkit";

const fetchFromLocalStorage = () => {
    let favorite = localStorage.getItem('favorite');
    if(favorite){
        return JSON.parse(localStorage.getItem('favorite'));
    } else {
        return [];
    }
}

const storeInLocalStorage = (data) => {
    localStorage.setItem('favorite', JSON.stringify(data));
}

const initialState = {
    favorites: fetchFromLocalStorage(),
    itemsCounts: 0,
    totalAmount: 0,
    isfavoriteMessageOn: false
}

const favoriteSlice = createSlice({
    name: 'favorite',
    initialState,
    reducers: {
        addTofavorite: (state, action) => {
            const isItemInfavorite = state.favorites.find(item => item.id === action.payload.id);

            if(isItemInfavorite){
                const tempfavorite = state.favorites.map(item => {
                    if(item.id === action.payload.id){
                        let tempQty = item.quantity + action.payload.quantity;
                        let tempTotalPrice = tempQty * item.price;

                        return {
                            ...item, quantity: tempQty, totalPrice: tempTotalPrice
                        }
                    } else {
                        return item;
                    }
                });

                state.favorites = tempfavorite;
                storeInLocalStorage(state.favorites);
            } else {
                state.favorites.push(action.payload);
                storeInLocalStorage(state.favorites);
            }
        },

        removeFromfavorite: (state, action) => {
            const tempfavorite = state.favorites.filter(item => item.id !== action.payload);
            state.favorites = tempfavorite;
            storeInLocalStorage(state.favorites);
        },

        clearfavorite: (state) => {
            state.favorites = [];
            storeInLocalStorage(state.favorites);
        },

        getfavoriteTotal: (state) => {
            state.totalAmount = state.favorites.reduce((favoriteTotal, favoriteItem) => {
                return favoriteTotal += favoriteItem.totalPrice
            }, 0);

            state.itemsCounts = state.favorites.length;
        },

        togglefavoriteQty: (state, action) => {
            const tempfavorite = state.favorites.map(item => {
                if(item.id === action.payload.id){
                    let tempQty = item.quantity;
                    let tempTotalPrice = item.totalPrice;

                    if(action.payload.type === "INC"){
                        tempQty++;
                        if(tempQty === item.stock) tempQty = item.stock;
                        tempTotalPrice = tempQty * item.discountedPrice;
                    }

                    if(action.payload.type === "DEC"){
                        tempQty--;
                        if(tempQty < 1) tempQty = 1;
                        tempTotalPrice = tempQty * item.discountedPrice;
                    }

                    return {...item, quantity: tempQty, totalPrice: tempTotalPrice};
                } else {
                    return item;
                }
            });

            state.favorites = tempfavorite;
            storeInLocalStorage(state.favorites);
        },

        setfavoriteMessageOn: (state) => {
            state.isfavoriteMessageOn = true;
        },

        setfavoriteMessageOff: (state) => {
            state.isfavoriteMessageOn = false;
        }
    }
});

export const {addTofavorite, setfavoriteMessageOff, setfavoriteMessageOn, getfavoriteTotal, togglefavoriteQty, clearfavorite, removeFromfavorite} = favoriteSlice.actions;
export const getAllfavorites = (state) => state.favorite.favorites;
export const getfavoriteItemsCount = (state) => state.favorite.itemsCounts;
export const getfavoriteMessageStatus = (state) => state.favorite.isfavoriteMessageOn;

export default favoriteSlice.reducer;